const comments = [
  {
    avatar: '匿',
    name: '吃瓜群众A',
    time: '3小时前',
    content: '这个网站真的太宝藏了！终于找到一个可以一站式看完所有吃瓜视频的地方，更新速度也超快，每天必刷。',
    likes: 256,
  },
  {
    avatar: '爆',
    name: '匿名爆料人',
    time: '6小时前',
    content: '之前通过投稿通道爆料了一条视频，没想到第二天就上了首页热门，编辑处理速度很快，而且确实保护了我的隐私。',
    likes: 189,
  },
  {
    avatar: '瓜',
    name: '资深瓜友',
    time: '12小时前',
    content: '对比了好几个吃瓜平台，17吃瓜网的内容质量确实更高，没有乱七八糟的广告，视频加载也快，已经推荐给朋友了。',
    likes: 134,
  },
  {
    avatar: '粉',
    name: '追瓜小能手',
    time: '1天前',
    content: '那个网红翻车合集笑死我了，每一段都高能！希望多出这种合集类的专题，一次性看过瘾。',
    likes: 97,
  },
  {
    avatar: '新',
    name: '新来的吃瓜人',
    time: '2天前',
    content: '朋友推荐的，一开始以为是普通八卦站，没想到内容这么硬核。娱乐圈那个CP塌房合集把我三观都震碎了。',
    likes: 63,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-accent-700 bg-accent-100 px-3 py-1 rounded-full mb-3">
            用户声音
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            吃瓜评论
          </h2>
        </div>

        <div className="space-y-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 hover:border-background-300/60 transition-colors"
            >
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="text-primary-600 font-bold text-sm">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-medium text-sm text-foreground-800">{comment.name}</span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
                  <div className="flex items-center gap-4 mt-3">
                    <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i> {comment.likes}
                    </button>
                    <button className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      回复
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}